import React, { useState } from 'react';
import AppSidebar from '../AppSidebar';
import DataUser from './DataUser';

function Dashboard({profile, setProfile}) {
  // const [profile, setProfile] = useState(localStorage.getItem('name') || '');

  return (
    <div>
      <AppSidebar setProfile={setProfile} />
      <div className="wrapper d-flex flex-column min-vh-100">
        {/* <Header profile={profile} />  */}
        <div className="body flex-grow-1">
          {/* <AppContent /> */}
          {/* Renderiza MyMapComponent */}
          {/* <MyMapComponent />  */}
          <DataUser profile={profile} setProfile={setProfile} />
        </div>
        {/* <AppFooter /> */}
      </div>
    </div>
  );
}

export default Dashboard;